import { getContext, onMount, onDestroy } from 'svelte';
import { key } from './store';

export const renderable = (render) => {
  const api = getContext(key);

  const element = {
    ready: false,
    mounted: false,
  };
  if (typeof render === 'function') element.render = render;
  else if (render) {
    if (render.render) element.render = render.render;
    if (render.setup) element.setup = render.setup;
  }
  api.add(element);

  onMount(() => {
    element.mounted = true;
    return () => {
      api.remove(element);
      element.mounted = false;
    };
  });
};
